import ListView from "./list-view";
import CollectionState from "./collection-state";
import CollectionFilters from "./collection-filters";
import { clone } from "../utils";
import IListViewState from "../interface/list-view-state";
import IListView from "../interface/list-view";
import IEntityFilter from "../interface/entity-filter";
import ErrorCode from "../enum/error-code";

// TODO - Backbone delete - this is used only for Backbone, and should be removed when this will gone
// TODO - Backbone delete - after delete you have to merge ListView.setFilters, ListView.setSorting into single ListView.setState call

class ExtrasSingleton {

    public async viewSetFilters(viewId: number, filters: IEntityFilter[]): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            const state: IListViewState = clone(view.state);
            state.filters = CollectionFilters.process(filters);
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async viewToggleFieldSort(viewId: number, fieldId: number, save: boolean): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            let state: IListViewState = clone(view.state);
            state = CollectionState.toggleFieldSort(view.entityId, state, fieldId);
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async viewSetFieldsOrder(viewId: number, order: number[]): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            const state: IListViewState = clone(view.state);
            state.fieldsOrder = CollectionState.validateFields(view.entityId, order);
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async viewSetFieldWidth(viewId: number, fieldId: number, width: number): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            let state: IListViewState = clone(view.state);
            state = CollectionState.setFieldWidth(view.entityId, state, fieldId, width);
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async viewToggleFieldHidden(viewId: number, fieldId: number): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            let state: IListViewState = clone(view.state);
            state = CollectionState.toggleFieldHidden(view.entityId, state, fieldId);
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async viewToggleLocked(viewId: number, fieldId: number): Promise<IListView> {
        const view: IListView | null = ListView.get(viewId);
        if (view) {
            let state: IListViewState = clone(view.state);
            state.fieldLocked = state.fieldLocked === fieldId ? null : fieldId;
            return await ListView.saveState(viewId, state);
        } else {
            throw ErrorCode.BadArguments;
        }
    }

}

const Extras = new ExtrasSingleton();

export default Extras;